._app_1lq8u_1 {
  margin-top: 19px;
  padding-top: 3px;
  padding-bottom: 19px; }

._illustration_1lq8u_6 {
  max-width: 100%; }

._presetItem_1lq8u_9 {
  cursor: pointer;
  width: 304px;
  margin: 0 auto 10px; }

._presetItemName_1lq8u_14 {
  margin-bottom: 6px; }
